import { TablesInsert } from "@/lib/supabase/supabase_types_override";
import { supabase } from "@/lib/supabase/supabaseClient";

export const createCrmConfig = async (data: TablesInsert<"crm_config">) => await supabase.from("crm_config").insert(data).throwOnError()
